<template>
  <div class="list-view">
    <!-- Barre de recherche identique -->
    <div class="search-wrapper">
      <FontAwesomeIcon icon="search" class="search-icon" />
      <input
        class="search"
        type="text"
        v-model="searchTerm"
        placeholder="Rechercher une association"
      />
    </div>

    <div class="filter-bar">
      <!-- Emplacement -->
      <div class="filter-group">
        <div class="filter-header" @click="toggleGroup('lieux')">
          <span>Emplacement</span>
          <span class="arrow" :class="{ open: openStates.lieux }">▾</span>
        </div>
        <transition name="fade">
          <div class="options" v-show="openStates.lieux">
            <label
              v-for="city in $store.getters.getPlaces"
              :key="'province-'+city.id"
            >
              <input
                type="checkbox"
                :value="city.id"
                v-model="filters.lieux"
              />
              {{ city.title }}
            </label>
          </div>
        </transition>
      </div>

      <!-- Publics -->
      <div class="filter-group">
        <div class="filter-header" @click="toggleGroup('publics')">
          <span>Publics</span>
          <span class="arrow" :class="{ open: openStates.publics }">▾</span>
        </div>
        <transition name="fade">
          <div class="options" v-show="openStates.publics">
            <label
              v-for="pub in $store.getters.getPublics"
              :key="'public-'+pub.id"
            >
              <input
                type="checkbox"
                :value="pub.id"
                v-model="filters.publics"
              />
              {{ pub.title }}
            </label>
          </div>
        </transition>
      </div>

      <!-- Catégorie -->
      <div class="filter-group filter-group--categories">
        <div class="filter-header" @click="toggleGroup('categories')">
          <span>Catégorie</span>
          <span class="arrow" :class="{ open: openStates.categories }">▾</span>
        </div>
        <transition name="fade">
          <div class="options" v-show="openStates.categories">
            <CategoryTreeCheckbox
              v-for="root in $store.getters.getCategories"
              :key="root.id"
              :node="root"
              v-model="filters.categories"
            />
          </div>
        </transition>
      </div>

      <!-- Accessibilité -->
      <div class="filter-group">
        <div class="filter-header" @click="toggleGroup('accessibilities')">
          <span>Accessibilité</span>
          <span class="arrow" :class="{ open: openStates.accessibilities }">▾</span>
        </div>
        <transition name="fade">
          <div class="options" v-show="openStates.accessibilities">
            <label
              v-for="acc in $store.getters.getAccessibilities"
              :key="'acc-'+acc.id"
            >
              <input
                type="checkbox"
                :value="acc.id"
                v-model="filters.accessibilities"
              />
              {{ acc.title }}
            </label>
          </div>
        </transition>
      </div>

      <div class="filter-group">
        <div class="filter-header" @click="toggleGroup('contexts')">
          <span>Contexte d'intervention</span>
          <span class="arrow" :class="{ open: openStates.contexts }">▾</span>
        </div>
        <transition name="fade">
          <div class="options" v-show="openStates.contexts">
            <label
              v-for="cont in $store.getters.getContexts"
              :key="'cont-'+cont.id"
            >
              <input
                type="checkbox"
                :value="cont.id"
                v-model="filters.contexts"
              />
              {{ cont.title }}
            </label>
          </div>
        </transition>
      </div>
    </div>

    <!-- Grille de cartes -->
    <div class="cards">
      <AssoComponent
        v-for="asso in filteredAssociations"
        :key="asso.id"
        :nom="asso.name"
        :image="asso.image"
        :description="asso.description"
        :lieux="asso.lieuxTitles"
        @select="openModal(asso)"
      />
    </div>

    <!-- Modale -->
    <AssociationModal
      v-if="showModal"
      :association="selectedAsso"
      @close="closeModal"
    />
  </div>
</template>

<script>
import AssoComponent from './AssoComponent.vue'
import CategoryTreeCheckbox from './CategoryTreeCheckbox.vue'
import AssociationModal from './AssociationModal.vue'

export default {
  name: 'ListView',
  components: { AssoComponent, CategoryTreeCheckbox, AssociationModal },
  data() {
    return {
      searchTerm: '', // <— ajouté
      filters: { lieux: [], categories: [], publics: [], accessibilities: [], contexts:[] },
      placesMap: {},
      showModal: false,
      selectedAsso: null,
      openStates: { lieux: false, categories: false, publics: false, accessibilities: false, contexts:false }
    }
  },
  computed: {
    associations() {
      return this.$store.getters.getAssociations
    },
    filteredAssociations() {
      const f = this.filters
      const term = this.searchTerm.trim().toLowerCase() // <— ajouté
      return this.associations
        .filter(a =>
          (!term || a.name.toLowerCase().includes(term)) && // <— filtre de recherche
          (!f.lieux.length || a.place.some(id => f.lieux.includes(id))) &&
          (!f.categories.length || a.category.some(id => f.categories.includes(id))) &&
          (!f.publics.length || a.public.some(id => f.publics.includes(id))) &&
          (!f.accessibilities.length || a.accessibility.some(id => f.accessibilities.includes(id))) &&
          (!f.contexts.length || a.context.some(id => f.contexts.includes(id)))
        )
        .map(a => ({ ...a, lieuxTitles: a.place.map(id => this.placesMap[id] || 'Inconnu') }))
    }
  },
  watch: {
    '$store.getters.getPlaces': {
      handler(places) {
        const m = {}
        places.forEach(p => (m[p.id] = p.title))
        this.placesMap = m
      },
      immediate: true
    }
  },
  methods: {
    toggleGroup(group) {
      this.openStates[group] = !this.openStates[group]
    },
    openModal(asso) {
      this.selectedAsso = asso
      this.showModal = true
    },
    closeModal() {
      this.showModal = false
      this.selectedAsso = null
    }
  },
  created() {
    this.$store.dispatch('loadAssociationPlaces')
    this.$store.dispatch('loadAssociationCategories')
    this.$store.dispatch('loadAssociationPublics')
    this.$store.dispatch('loadAssociationAccessibilities')
    this.$store.dispatch('loadAssociationContexts')
    this.$store.dispatch('loadAssociations')
  }
}
</script>

<style scoped>
.list-view {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #F5F5F5;
  padding-left: 1rem;
  padding-right: 1rem;
}

/* ——— Barre de recherche (copiée à l’identique de la page admin) ——— */
.search-wrapper {
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 500px;
  margin: 1.5rem auto;
  position: relative;
}
.search-icon {
  position: absolute;
  left: 1rem;
  font-size: 1rem;
  color: #bbb;
  pointer-events: none;
}
.search {
  flex: 1;
  padding: 0.75rem 1rem 0.75rem 2.5rem;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.08);
  transition: border-color 0.3s, box-shadow 0.3s;
}
.search:focus {
  outline: none;
  border-color: #1E1C66;
  box-shadow: 0 0 0 3px rgba(30,28,102,0.15);
}

/* ——— Filtres ——— */
.filters-title {
  font-size: 1.6rem;
  font-weight: bold;
  color: #1E1C66;
  margin-bottom: 1rem;
}

.filter-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 2rem;
  align-items: flex-start;
}

.filter-group {
  flex: 1 1 220px;
  align-self: flex-start;
  border-radius: 8px;
  background: #FFFFFF;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: visible;
  position: relative;
  border: 1px solid #E0E0E0;
  border-radius: 8px;
}

.options {
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  background: #F9F9F9;
  text-align: start;
  position: absolute;
  top: 100%;
  left: 0;
  width: 88%;
  z-index: 10;
  max-height: 300px;
  overflow-y: auto;
}
.filter-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.8rem 1rem;
  background: #167580;
  color: #FFFFFF;
  font-weight: bold;
  cursor: pointer;
  user-select: none;
  border-radius: 8px;
}
.filter-header:hover { background: #12626b; }

.arrow { transition: transform 0.3s ease; }
.arrow.open { transform: rotate(180deg); }

.fade-enter-from, .fade-leave-to { opacity: 0; }

.options label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.95rem;
  color: #1E1C66;
}
.options input[type="checkbox"] {
  width: 16px;
  height: 16px;
  accent-color: #167580;
}

.cards {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1.5rem;
}

/* Responsive mobile */
@media (max-width: 768px) {
  .filter-bar { justify-content: center; gap:0.5rem; }
  .filter-group {
    flex: 1 1 130px;
    align-self: flex-start;
    background: #FFFFFF;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    overflow: visible;
    position: relative;
    border: 1px solid #E0E0E0;
    border-radius: 8px;
  }
  .filter-header {
    display: flex;
    justify-content: space-between;
    align-items:start;
    padding: 0.8rem;
    background: #167580;
    color: #FFFFFF;
    cursor: pointer;
    user-select: none;
    border-radius: 8px;
  }
  .filter-group--categories .options { width: 190%; }
  .cards { gap: 1rem; }

  /* réduire la barre de recherche sur mobile pour garder l’aspect identique */
  .search-wrapper { margin: 1rem auto; }
}
</style>
